import { ZD_DIRECTORY_ID, ZD_TEST_DIRECTORY_ID } from './constants';

export default function isZocdocBrand(directoryId) {
    return (
        directoryId === ZD_DIRECTORY_ID || directoryId === ZD_TEST_DIRECTORY_ID
    );
}
